/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useState, useEffect } from 'react';
import { Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import io from 'socket.io-client';
import { TableContext } from '../../contexts/tableContext';
// import DarkMode from '../DarkMode';
import styles from './Header.module.scss';
import { getCookies, removeCookies } from '../../hooks/useCookies';
import { CapitalizeFirstLetter } from '../../utilityFunctions/utilsFunctions';
import { SOCKET_CONNECT_URL } from '../../redux/apiConstants';
// import { SERVER_BASE_URL } from '../../redux/apiConstants';

function Header() {
  const { dashboardStyle } = useContext(TableContext);
  const { dashboardHeader } = useContext(TableContext);
  const { bodyheader } = useContext(TableContext);
  const { headerbgStyle } = useContext(TableContext);
  const navigate = useNavigate();

  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationMessages, setNotificationMessages] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [socket, setSocket] = useState(null);

  const handleNotificationClick = () => {
    const newDropdownState = !showDropdown;
    setShowDropdown(newDropdownState);

    if (newDropdownState) {
      setNotificationCount(0);
      setHasUnreadMessages(false);
      setNotificationMessages((prev) => prev.map((msg) => ({ ...msg, isNew: false })));
    } else {
      if (socket) {
        socket.emit('clearNotificationCount');
      }
    }
  };

  const handleDropdownItemClick = () => {
    if (socket) {
      socket.emit('clearOldUsers');
    }
    setNotificationMessages([]);
    setNotificationCount(0);
    setShowDropdown(false);
    setHasUnreadMessages(false);
    navigate('/appuser');
  };

  const handleClearAll = () => {
    if (socket) {
      socket.emit('clearOldUsers');
    }
    setNotificationMessages([]);
    setNotificationCount(0);
    setHasUnreadMessages(false);
    setShowDropdown(false);
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest('.notification-container')) {
      if (showDropdown) {
        if (socket) {
          socket.emit('clearNotificationCount');
        }
      }
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    const userId = getCookies('USERID');
    const token = getCookies('Token');

    if (!userId || !token) return undefined;

    const socketConnection = io(SOCKET_CONNECT_URL, {
      transports: ['websocket', 'polling'],
      auth: {
        token,
      },
    });

    setSocket(socketConnection);

    socketConnection.emit('joinAdminNotifications');

    socketConnection.emit('getNotificationState');

    socketConnection.on('bell-count-update', (data) => {
      setNotificationCount(data.count || 0);
    });

    socketConnection.on('notificationState', (state) => {
      const existingMessages = state.users.map((user) => ({
        id: user.userId,
        name: user.name,
        email: user.email,
        userType: 'appUser',
        timestamp: user.timestamp,
        isNew: user.isNew,
        message: `${user.email} joined as an app user.`,
      }));

      setNotificationMessages(existingMessages);
      setNotificationCount(state.newCount);
      setHasUnreadMessages(state.newCount > 0);
    });

    socketConnection.on('new-signup', (notificationData) => {
      // eslint-disable-next-line no-console
      console.log('New signup notification:', notificationData);

      setNotificationMessages((prev) => {
        const existingMessage = prev.find(
          (msg) => msg.id === (notificationData.user.id || notificationData.user._id)
        );
        if (existingMessage) {
          return prev;
        }

        const newMessage = {
          id: notificationData.user.id || notificationData.user._id,
          name: notificationData.user.name,
          email: notificationData.user.email,
          userType: notificationData.userType,
          timestamp: notificationData.timestamp,
          isNew: notificationData?.isNew || true,
          message: `${notificationData.user.name || notificationData.user.email} joined as ${
            notificationData.user.roles === 'property_owner' ? 'Property Owner' : 'Service Provider'
          }`,
        };

        return [newMessage, ...prev];
      });

      setHasUnreadMessages(true);
    });

    socketConnection.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    return () => {
      socketConnection.disconnect();
    };
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  console.log(notificationMessages);

  const logOut = () => {
    confirmAlert({
      title: 'Confirm to logout',
      message: 'Are you sure want to logout ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            removeCookies('Token');
            removeCookies('refreshToken');
            window.location.href = '/login';
            // return false;
          },
        },
        {
          label: 'No',
          // onClick: () => alert("Click No")
        },
      ],
    });
  };
  const userName = getCookies('USERNAME') ? getCookies('USERNAME') : 'Username';
  const userRole = getCookies('USERROLE') ? CapitalizeFirstLetter(getCookies('USERROLE')) : 'Role';
  const profileImage = getCookies('PROFILE');
  return (
    <div className={styles[headerbgStyle]}>
      <div className={styles[dashboardStyle]} id={styles.headermobile}>
        <div className={styles.leftnav}>
          <h1 className={styles[bodyheader]} id={styles.dashboard_heading}>
            {dashboardHeader}
          </h1>
        </div>
        <div className={styles.rightnav}>
          <ul className="nav justify-content-end" id={styles.ulnav}>
            <li className="nav-item" id={styles.darkmodeleft} style={{ marginRight: '10px' }}>
              <div className="notification-container" style={{ position: 'relative' }}>
                <div
                  className={styles.notificationContainer}
                  onClick={handleNotificationClick}
                  onKeyPress={(e) => e.key === 'Enter' && handleNotificationClick()}
                  role="button"
                  tabIndex={0}
                >
                  <FontAwesomeIcon icon={faBell} className={styles.bellicon} />
                  {notificationCount > 0 && (
                    <span className={styles.notificationBadge}>
                      {notificationCount > 99 ? '99+' : notificationCount}
                    </span>
                  )}
                </div>

                {/* Notification Dropdown */}
                {showDropdown && (
                  <div className={styles.notificationDropdown}>
                    <div className={styles.dropdownHeader}>
                      <div className={styles.headerContent}>
                        <h6>New User Notifications</h6>
                        {notificationMessages.length > 0 && (
                          <button
                            className={styles.clearAllButton}
                            onClick={handleClearAll}
                            type="button"
                          >
                            Clear All
                          </button>
                        )}
                      </div>
                    </div>
                    {notificationMessages.length > 0 ? (
                      <div className={styles.dropdownContent}>
                        {notificationMessages.map((message) => (
                          <div
                            key={message.id}
                            className={`${styles.notificationItem} ${
                              message.isNew ? styles.newMessage : ''
                            }`}
                            onClick={handleDropdownItemClick}
                            onKeyPress={(e) => e.key === 'Enter' && handleDropdownItemClick()}
                            role="button"
                            tabIndex={0}
                          >
                            <div className={styles.messageContent}>
                              <p className={message.isNew ? `${styles.boldText}` : ''}>
                                {message.message}
                              </p>
                              <small>
                                {new Date(message.timestamp).toLocaleString('en-US', {
                                  month: 'short',
                                  day: 'numeric',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                                })}
                              </small>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className={styles.noNotifications}>
                        <p>No new notifications</p>
                      </div>
                    )}
                    <div className={styles.dropdownFooter}>
                      <button
                        className={styles.viewAllButton}
                        onClick={handleDropdownItemClick}
                        type="button"
                      >
                        View All Users
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </li>
            <li className="nav-item dropdown" id={styles.dropdown}>
              <a
                className="rounded-circle "
                href="#!"
                role="button"
                id="dropdownUser"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <div
                  className={` ${styles.avatar} ${styles.avatar_md} ${styles.avatar_indicators} ${styles.avatar_online}`}
                >
                  <Image src={profileImage} alt="logo" className={styles.profilepic} />
                </div>
              </a>

              <div
                className="dropdown-menu pb-2"
                aria-labelledby="dropdownUser"
                id={styles.dropdown_menu}
              >
                <div className="dropdown-item">
                  <div className="d-flex py-2">
                    <div
                      className={` ${styles.avatar} ${styles.avatar_md} ${styles.avatar_indicators} ${styles.avatar_online}`}
                    >
                      <Image src={profileImage} alt="logo" className={styles.profilepic} />
                    </div>
                    <div className="ml-3 lh-1">
                      <h5 className={styles.profilename}>{userName}</h5>
                      <p className={styles.profilerole}>{userRole}</p>
                    </div>
                  </div>
                </div>
                <div className="dropdown-divider" />
                <div className="">
                  <ul className="list-unstyled">
                    {/* <li className="dropdown-submenu dropright-lg" id={styles.dropdown_submenu}>
                      <a
                        className="dropdown-item dropdown-list-group-item dropdown-toggle"
                        id={styles.dropdown_toggle}
                        href="#!"
                      >
                        Status
                      </a>
                      <ul className="dropdown-menu" id={styles.dropdown_menu}>
                        <li>
                          <a className="dropdown-item text-success" href="#!">
                            Online
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item text-black-50" href="#!">
                            Offline
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item text-info" href="#!">
                            Away
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item text-danger" href="#!">
                            Busy
                          </a>
                        </li>
                      </ul>
                    </li> */}
                    <li>
                      <Link
                        data-tooltip="Profile"
                        className="dropdown-item"
                        id={styles.droplink}
                        to="/profile"
                      >
                        {' '}
                        Profile{' '}
                      </Link>
                    </li>
                    <li>
                      <Link
                        data-tooltip="Settings"
                        className="dropdown-item"
                        id={styles.droplink}
                        to="/settings"
                      >
                        {' '}
                        Settings{' '}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown-divider" />
                <ul className="list-unstyled">
                  <li>
                    <a
                      className="dropdown-item"
                      id={styles.droplink}
                      onClick={logOut}
                      onKeyPress={logOut}
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            {/* <li className="nav-item">
              <span className={styles[bodyheader]} id={styles.profilename}>
                {userName}
              </span>
              <br />
              <p className={styles.profilerole}>{userRole}</p>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Header;
